import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useAuth } from '@/context';
import { COGNITO_GROUP_BI_PREMIACAO } from '@/utils/cognitoGroups';
import DashboardDepositoMain from './components/DashboardDepositoMain';
import DashboardMotoristasMain from './components/DashboardMotoristasMain';
import DashboardPremiacaoMain from './components/DashboardPremiacaoMain';

const DashboardPremiacaoRoute = () => {
  const { hasCognitoGroup } = useAuth();

  if (!hasCognitoGroup(COGNITO_GROUP_BI_PREMIACAO)) {
    return <Redirect to="/pages/dashboard/deposito" />;
  }

  return <DashboardPremiacaoMain />;
};

const DashboardMain = () => (
  <Switch>
    <Route exact path="/pages/dashboard" render={() => <Redirect to="/pages/dashboard/deposito" />} />
    <Route exact path="/pages/dashboard/deposito" component={DashboardDepositoMain} />
    <Route exact path="/pages/dashboard/premiacao" component={DashboardPremiacaoRoute} />
    <Route exact path="/pages/dashboard/motoristas" component={DashboardMotoristasMain} />
  </Switch>
);

export default DashboardMain;

